import React, { useMemo } from 'react'
import { ThemeProvider } from '@mui/material/styles'

import { createAppTheme } from '../../theme/createAppTheme'
import { useBrandingConfiguration } from '../../features/Configuration/BrandingConfiguration/hooks/useBrandingConfiguration'

interface BrandingThemeProviderProps {
  children: React.ReactNode
}

const BrandingThemeProvider: React.FC<BrandingThemeProviderProps> = ({ children }) => {
  const { configuration, effective, isLoading } = useBrandingConfiguration()

  const theme = useMemo(() => createAppTheme({ branding: effective }), [effective])

  if (isLoading && !configuration) {
    return null
  }

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default BrandingThemeProvider
